/* Welcome-offer popup: intent first, address second.

   Held back until the visitor has shown intent (scroll depth or dwell) rather
   than firing on load — a modal that lands before the page does is the single
   most-closed element on any storefront. Dismissal is remembered for 30 days
   and a successful signup is remembered for good. */
(function () {
  var KEY = 'sv-pop';
  var DAYS = 30;

  function state() {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}'); }
    catch (e) { return {}; }
  }
  function remember(patch) {
    try {
      localStorage.setItem(KEY, JSON.stringify(Object.assign(state(), patch)));
    } catch (e) {}
  }

  function suppressed() {
    var s = state();
    if (s.joined) return true;
    if (!s.dismissedAt) return false;
    return (Date.now() - s.dismissedAt) < DAYS * 864e5;
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else { fn(); }
  }

  ready(function () {
    var pop = document.querySelector('[data-sv-pop]');
    if (!pop) return;

    var steps = {
      1: pop.querySelector('[data-sv-pop-step="1"]'),
      2: pop.querySelector('[data-sv-pop-step="2"]'),
      3: pop.querySelector('[data-sv-pop-step="3"]')
    };

    function show(n) {
      Object.keys(steps).forEach(function (k) {
        if (steps[k]) steps[k].hidden = Number(k) !== n;
      });
    }

    // a gift buyer is being asked for someone else's date
    function adaptHint(intent) {
      var hint = pop.querySelector('[data-sv-pop-hint]');
      if (!hint) return;
      hint.textContent = intent === 'looking-for-a-gift'
        ? "We'll remind you when to order so it arrives in time for their day."
        : "We'll remind you when to order so it arrives in time — nothing else.";
    }

    function open(step) {
      pop.hidden = false;
      pop.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      show(step || 1);
    }

    function close() {
      pop.hidden = true;
      pop.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      remember({ dismissedAt: Date.now() });
    }

    pop.querySelectorAll('[data-sv-pop-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !pop.hidden) close();
    });

    // step 1 -> 2, carrying the answer into the customer tags
    pop.querySelectorAll('[data-sv-intent]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        remember({ intent: btn.dataset.svIntent });
        syncTags();
        adaptHint(btn.dataset.svIntent);
        show(2);
        var email = pop.querySelector('#sv-pop-email');
        if (email) email.focus();
      });
    });

    // The wedding date has no home in Shopify's customer form, so it travels
    // as a tag — wedding-date:YYYY-MM-DD — and a Flow lifts it into a metafield
    // on the other side. Tags are the only free-form field the form persists.
    var dateField = pop.querySelector('[data-sv-pop-date]');
    var tagsField = pop.querySelector('[data-sv-pop-tags]');

    function syncTags() {
      if (!tagsField) return;
      var tags = ['newsletter'];
      var s = state();
      if (s.intent) tags.push(s.intent);
      // A past date is not an error — it means they are already married, which
      // is the anniversary flow's whole input. Only a nonsense year is rejected.
      if (dateField && /^\d{4}-\d{2}-\d{2}$/.test(dateField.value)) {
        var year = Number(dateField.value.slice(0, 4));
        if (year >= 1950 && year <= 2060) {
          tags.push('wedding-date:' + dateField.value);
        }
      }
      tagsField.value = tags.join(',');
    }

    if (dateField) {
      dateField.addEventListener('change', syncTags);
    }

    var form = pop.querySelector('#sv-pop-form');
    if (form) {
      form.addEventListener('submit', function () {
        syncTags();
        // Shopify reloads the page on success; remember before we lose the JS
        remember({ joined: true });
      });
    }

    // Shopify redirects back with ?customer_posted=true; the Liquid side also
    // stamps the wrapper when form.posted_successfully? is set
    if (pop.hasAttribute('data-sv-pop-joined') ||
        /[?&]customer_posted=true/.test(window.location.search)) {
      remember({ joined: true });
      open(3);
      return;
    }

    if (suppressed()) return;

    var fired = false;
    function trigger() {
      if (fired) return;
      fired = true;
      open(1);
    }

    // Exit intent: the pointer leaving through the top of the window is the
    // last moment the offer can still land, and it costs the visitor nothing
    // because they were leaving anyway. Only on devices with a real pointer —
    // a phone has no equivalent gesture, and the ones people fake (scroll-up,
    // back-button traps) read as hostile.
    if (window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', function onExit(e) {
        if (e.relatedTarget || e.clientY > 12) return;   // still inside the page
        document.removeEventListener('mouseout', onExit);
        trigger();
      });
    }
    // whichever comes first: 12s of dwell, or a third of the page scrolled.
    // The theme scrolls inside a container, not the document, so window.scrollY
    // never moves — listen in the capture phase and measure the element that
    // actually scrolled.
    var timer = window.setTimeout(trigger, 12000);
    function onScroll(event) {
      var el = event.target;
      var top, height, view;
      if (el === document || el === document.documentElement || !el.scrollHeight) {
        top = window.scrollY;
        height = document.documentElement.scrollHeight;
        view = window.innerHeight;
      } else {
        top = el.scrollTop;
        height = el.scrollHeight;
        view = el.clientHeight;
      }
      if (height <= view) return;
      if ((top + view) / height > 0.33) {
        window.clearTimeout(timer);
        document.removeEventListener('scroll', onScroll, true);
        trigger();
      }
    }
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  });
})();
